import InsightsApi from '@/api/insights.api'

const state = {
  offerInsights: [],
  sellerOfferInsight: null,
  revenueChart: {
    dataPoints: [],
    summary: null,
    loading: false,
    error: null
  },
  campaignChart: {
    dataPoints: [],
    loading: false,
    error: null
  }
}

const getters = {
  revenueChartData: (state) => state.revenueChart.dataPoints,
  revenueChartSummary: (state) => state.revenueChart.summary,
  isRevenueChartLoading: (state) => state.revenueChart.loading,
  campaignChartData: (state) => state.campaignChart.dataPoints,
  isCampaignChartLoading: (state) => state.campaignChart.loading
}

const actions = {
  async fetchAllOfferInsights({ commit }) {
    const response = await InsightsApi.getAllOfferInsights()
    commit('SET_OFFER_INSIGHTS', response.data || [])
    return response.data
  },

  async fetchSellerOfferInsights({ commit }, sellerOfferId) {
    const response = await InsightsApi.getSellerOfferInsights(sellerOfferId)
    commit('SET_SELLER_OFFER_INSIGHT', response.data || null)
    return response.data
  },

  async fetchRevenueChart({ commit }, { granularityColumn = 'datesByYearMonth' } = {}) {
    commit('SET_REVENUE_CHART_LOADING', true)
    commit('SET_REVENUE_CHART_ERROR', null)

    try {
      const response = await InsightsApi.getRevenueChart({
        granularityColumn
      })

      commit('SET_REVENUE_CHART_DATA', response.data)
      return response.data
    } catch (error) {
      commit('SET_REVENUE_CHART_ERROR', error.message || 'Failed to fetch revenue chart data')
      throw error
    } finally {
      commit('SET_REVENUE_CHART_LOADING', false)
    }
  },

  async fetchCategoryRPC({ commit }, { startDate = null, endDate = null, accountId = null, categoryName = null } = {}) {
    commit('SET_CAMPAIGN_CHART_LOADING', true)
    commit('SET_CAMPAIGN_CHART_ERROR', null)

    try {
      const response = await InsightsApi.getRpcByCategoryChart({
        startDate,
        endDate,
        accountId,
        categoryName
      })

      commit('SET_CAMPAIGN_CHART_DATA', response.data)
      return response.data
    } catch (error) {
      commit('SET_CAMPAIGN_CHART_ERROR', error.message || 'Failed to fetch category data')
      throw error
    } finally {
      commit('SET_CAMPAIGN_CHART_LOADING', false)
    }
  },

  reset({ commit }) {
    commit('RESET_INSIGHTS')
  }
}

const mutations = {
  SET_OFFER_INSIGHTS(state, data) {
    state.offerInsights = data
  },
  SET_SELLER_OFFER_INSIGHT(state, data) {
    state.sellerOfferInsight = data
  },
  SET_REVENUE_CHART_DATA(state, data) {
    // Data is raw Ringba API response: { report: { records: [...], partialResult: bool } }
    state.revenueChart.dataPoints = data?.report?.records || []
    state.revenueChart.summary = null // Frontend calculates summary if needed
  },
  SET_REVENUE_CHART_LOADING(state, loading) {
    state.revenueChart.loading = loading
  },
  SET_REVENUE_CHART_ERROR(state, error) {
    state.revenueChart.error = error
  },
  SET_CAMPAIGN_CHART_DATA(state, data) {
    state.campaignChart.dataPoints = data?.report?.records || []
  },
  SET_CAMPAIGN_CHART_LOADING(state, loading) {
    state.campaignChart.loading = loading
  },
  SET_CAMPAIGN_CHART_ERROR(state, error) {
    state.campaignChart.error = error
  },
  RESET_INSIGHTS(state) {
    state.offerInsights = []
    state.sellerOfferInsight = null
    state.revenueChart = {
      loading: false,
      error: null
    }
    state.campaignChart = {
      dataPoints: [],
      loading: false,
      error: null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
